export default "__VITE_ASSET__359ff699__"